import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconSuccessful16(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="successful">
            <circle
                cx="8"
                cy="8"
                r="8"
                fill={props.fill || 'currentColor'}
            />
            <path
                d="M4 8L7 11L13 5"
                stroke={props.stroke || props.foregroundcolor || 'black'}
                strokeWidth="2"
            />
        </svg>
    );
}

export function IconSuccessfulCircular24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="successful">
            <path
                d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.7216 8.69477L10.0168 17.3212L4.3501 11.6545L5.76431 10.2403L10.0976 14.5735L18.3928 7.19995L19.7216 8.69477Z"
                fill={props.foregroundcolor || 'black'}
            />
        </svg>
    );
}
